import { render } from "./Locker.vue?vue&type=template&id=56e46584"
import script from "./Locker.vue?vue&type=script&lang=js"
export * from "./Locker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__